class ProductFormSubmit extends HTMLElement {
  constructor() {
    super();

    this.style.display = "block";

    const elements = {
      form: this.closest("form"),
      button: this.querySelector("button")
    };

    elements.selling_plan = elements.form.querySelector("[name=selling_plan]");

    const setLoading = (loading) => {
      elements.button.classList.toggle("state--loading", loading);
      elements.button.toggleAttribute("aria-busy", loading);
    };

    elements.button.addEventListener("click", (event) => {
      event.preventDefault();

      if (elements.button.classList.contains("state--loading")) {
        return;
      }

      const data = new FormData(elements.form);

      if (elements.selling_plan && elements.selling_plan.disabled) {
        data.set("selling_plan", "");
      }

      const drawer = document.querySelector("cart-drawer");
      const room = drawer && typeof drawer.roomLeft === "number" ? drawer.roomLeft : Infinity;

      if (room < 1) {
        drawer.refuseAdd();

        return;
      }

      const requested = Number(data.get("quantity")) || 1;

      if (requested > room) {
        data.set("quantity", room);
        drawer.markLimitFlash();
      }

      setLoading(true);

      const release = () => {
        clearTimeout(fallback);
        document.removeEventListener("cartdrawer:show", release);
        setLoading(false);
      };

      const fallback = setTimeout(release, 8000);

      document.addEventListener("cartdrawer:show", release);

      fetch("/cart/add.js", {
        method: "POST",
        body: data
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if (response.status) {
          release();

          if (drawer) {
            drawer.refuseAdd(response.description || response.message);
          }

          console.error("ProductFormSubmitError: ", response);

          return;
        }

        document.dispatchEvent(new CustomEvent("addtocart", {
          detail: { ...response, quantity_added: Number(data.get("quantity")) || 1 }
        }));
      })
      .catch(error => {
        release();
        console.error("ProductFormSubmitError: ", error);
      });
    });
  }
}

customElements.define("product-form-submit", ProductFormSubmit);
